import React, { PureComponent } from 'react';

import { Card } from 'components/card';

import FileUploading from './FileUploading';

export default class FileCardUploading extends PureComponent {
  render() {
    return (
      <Card className="file__card">
        <FileUploading {...this.props} />
      </Card>
    );
  }
}
